import { render, staticRenderFns } from "./TelegramOtpDetailFilter.vue?vue&type=template&id=bff00742&"
import script from "./TelegramOtpDetailFilter.vue?vue&type=script&lang=ts&"
export * from "./TelegramOtpDetailFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports